import React, { useCallback, useEffect, useState } from "react";
import { Breadcrumb, Col, Form, Row } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Questions from "../../../../Components/Questions/Questions";
import BorderedSec from "../../../../UI/BorderedSec";
import Card from "../../../../UI/Card/Card";
import ConfirmationModal from "../../../../UI/ConfirmationModal/ConfirmationModal";
import Graybg from "../../../../UI/Graybg";
import Modals from "../../../../UI/Modals/Modals";
import SecBTN from "../../../../UI/SecBTN";
import SuccessModal from "../../../../UI/SuccessModal/SuccessModal";
import classes from "./Questions.module.css";
import userService from "../../../../app/services/user.service";
import Loader from "../../../../UI/loader/loader";
import { isEmpty, linkReplaceFn } from "../../../../utils/custom_funtions";
import './MatrixQuestionsPrint.css'; // Import print-specific CSS
// import classes1 from "../../../../Components/Questions/Questions.module.css";
import classes1 from "../../../../Components/Questions/Questions.module.css"

const MatrixQuestions = () => {
  const { state } = useLocation();
  const navigate = useNavigate()
  const { paper_id, sub_id, faculty_id, isBoth, syllabus, remarks, format, exam_date, assigned_q, date_submiossion, center, center_id } = state;

  console.log(paper_id, sub_id, faculty_id, isBoth, syllabus, remarks, format, exam_date, assigned_q, date_submiossion, center, center_id)
  //paper Detail popup
  const [showPopUp, setShowPopUp] = useState(false);
  //View Syllabus popup
  const [showPopUp1, setShowPopUp1] = useState(false);
  // Finish button
  const [showPopUp2, setShowPopUp2] = useState(false);
  //Finish confirmation handler
  const [showPopUp3, setShowPopUp3] = useState(false);
  const [loading, setloading] = useState(false);
  // Final Submit Paper checkbox
  const [isFinalPaper, setIsFinalPaper] = useState(false);
  // Data
  const [quesData, setQuesData] = useState([]);

  // useEffect(() => console.log("Quesdata changed"), [quesData]);
  const getRandomPaperData = () => {
    setloading(true);
    userService
      .getRandomPaper(state)
      .then((data) => {
        console.log('matrixdata.data.data', data.data.data);
        setQuesData(data.data.data);
        setloading(false);
      })
      .catch((error) => {
        console.log(error);
        setloading(false);
      });
  }

  useEffect(() => {
    getRandomPaperData();
  }, []);

  const hideHandler = () => {
    setShowPopUp(false);
    setShowPopUp1(false);
    setShowPopUp2(false);
  };

  const hideHandler1 = () => {
    setShowPopUp3(false);
    navigate('/createPaper', { state: { btnType: "Completed" } })
  }

  const paperDetailHandler = () => setShowPopUp(true);
  const viewSyllabusHandler = () => setShowPopUp1(true);
  const finishHandler = () => {
    setShowPopUp2(true);
  };
  const yesHandler = () => {
    userService
      .submitPaper({
        paper_id: paper_id,
        sub_id: sub_id,
        faculty_id: faculty_id,
        is_final_paper: isFinalPaper ? 1 : 0,
      })
      .then((res) => {
        console.log(res);
        setShowPopUp2(false);
        setShowPopUp3(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const replaceQuestionForNext = async (
    datas,
    // setShowPopUp5,
    // setShowPopUp7
    index
  ) => {
    // if (paraCondition) {

    const logicArr = datas.map((item, i) => {
      return { index: index + i, updateQ: false }
    })
    for (let i = 0; i < datas.length; i++) {
      await userService
        .updateQid({
          matrix_id: quesData[index + i].matrix_id,
          qid: datas[i].qid,
          faculty_id: quesData[index + i].faculty_id,
        })
        .then((res) => {
          console.log(res);
          logicArr[i].updateQ = true;
        })
        .catch((err) => {
          console.log(err);
        });
    }

    getRandomPaperData()

    // const arr = quesData; 

    // const processedData = logicArr.map((logic,i) => {
    //   if (logic.updateQ) {
    //     arr[logic.index] = {
    //       ...arr[logic.index],
    //       ...datas[i],
    //       paragraph_id:datas[i].para_id,
    //       m_p_text:
    //         linkReplaceFn(datas[i].m_p_text) ?? null,
    //       m_p_text_hindi:
    //         linkReplaceFn(datas[i].m_p_text_hindi) ?? null,
    //       p_text: linkReplaceFn(datas[i].p_text),
    //       p_text_hindi: linkReplaceFn(
    //         datas[i].p_text_hindi
    //       ),
    //       q_text: linkReplaceFn(datas[i].q_text),
    //       sol_text: linkReplaceFn(datas[i].sol_text),
    //       q_text_hindi: linkReplaceFn(
    //         datas[i].q_text_hindi
    //       ),
    //       sol_text_hindi: linkReplaceFn(
    //         datas[i].sol_text_hindi
    //       ),
    //       h_option: linkReplaceFn(datas[i].h_option),
    //       eng_option: linkReplaceFn(datas[i].eng_option),
    //     };
    //   }
    // })
    //   console.log("processedData",arr);

    //   setQuesData(arr)


    // setQuesData((prev) => {
    //   const processedData = prev.splice(index + i, 0, {
    //     ...prev[index + i],
    //     ...datas[i],

    //   });
    //   return processedData;
    // });
    // }
  }

  const [isPrintMode, setIsPrintMode] = useState(false);

  useEffect(() => {
    // Listen for print events
    const beforePrint = () => setIsPrintMode(true);
    const afterPrint = () => setIsPrintMode(false);
    window.addEventListener('beforeprint', beforePrint);
    window.addEventListener('afterprint', afterPrint);
    return () => {
      window.removeEventListener('beforeprint', beforePrint);
      window.removeEventListener('afterprint', afterPrint);
    };
  }, []);

  if (isPrintMode) {
    // PRINT MODE: Show questions in the same format as Questions module
    return (
      <div className="print-paper-matrix" style={{ paddingRight: 88 }}>
        <h2 className="text-center mb-3">Question Paper</h2>
        <div className="mb-3">
          <Row>
            <Col md={6} sm={12}><b>Paper Code:</b> {paper_id}</Col>
            <Col md={6} sm={12}><b>Format:</b> {format}</Col>
            <Col md={6} sm={12}><b>Exam Date:</b> {exam_date}</Col>
            <Col md={6} sm={12}><b>Questions Assigned:</b> {assigned_q}</Col>
            <Col md={6} sm={12}><b>Date Of Submission:</b> {date_submiossion}</Col>
            <Col md={6} sm={12}><b>Center:</b> {center}</Col>
            {syllabus && <Col md={12} sm={12}><b>Syllabus:</b> {syllabus}</Col>}
            {remarks && <Col md={12} sm={12}><b>Remarks:</b> {remarks}</Col>}
          </Row>
        </div>
        <div className="print-questions">
          {quesData?.map((data, index) => (
            <div key={index} className="mb-4">
              <div className={classes1["sec-card"]} style={{ marginBottom: 8 }}>
                <b>Qid :</b> {data.qid}
              </div>
              <div className={classes1["sec-card"]} style={{ marginBottom: 8 }}>
                <b>Topic :</b> {data.topic_name}
              </div>
              <div className={classes1["sec-card"]} style={{ marginBottom: 8 }}>
                <b>Sub-topic :</b> {data.sub_topic_name}
              </div>
              <div className={classes1["sec-card"]} style={{ marginBottom: 8 }}>
                <b>Toughness :</b> {data.toughness}
              </div>
              <div className={classes1["sec-card1"]} style={{ padding: 12 }}>
                <b>Question {data.qno} : </b>
                <span dangerouslySetInnerHTML={{ __html: data.q_text }} />
                <ol style={{ listStyleType: "upper-alpha", marginLeft: "30px" }}>
                  {data.eng_option && [...new Set(data?.eng_option?.split("@@@"))]?.map((opt, i) => (
                    <li key={i}><div dangerouslySetInnerHTML={{ __html: opt }} /></li>
                  ))}
                </ol>
              </div>
              <p className={classes1["crct-ans-opt"]}>
                Answer : <span>{data.answer}</span>
              </p>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="section">
      <button onClick={() => console.log(quesData)}>sgh</button>
      {loading && <Loader />}
      {/* Paper Details */}
      <Modals show={showPopUp} onHide={hideHandler} size="lg">
        <h4 className="mb-4">Paper Details</h4>
        <Row className="mt-3">
          <Col md={12} sm={12}>
            Paper Code : <b>{paper_id}</b>
          </Col>
          <Col md={12} sm={12}>
            Format : <b>{format}</b>
          </Col>
          <Col md={6} sm={12}>
            Exam Date : <b>{exam_date}</b>
          </Col>
          <Col md={6} sm={12}>
            Questions Assigned : <b>{assigned_q}</b>
          </Col>
          <Col md={6} sm={12}>
            Date Of Submission : <b>{date_submiossion}</b>
          </Col>
          <Col md={6} sm={12}>
            Center : <b>{center}</b>
          </Col>
        </Row>
      </Modals>
      {/* Syllabus */}
      <Modals show={showPopUp1} onHide={hideHandler} size="lg">
        <h4 className="mb-4">Syllabus</h4>
        <p>
          <span className="text-muted">Topic : </span>
          {syllabus}
        </p>
        <p>
          <span className="text-muted">Remarks : </span>
          {remarks}
        </p>
      </Modals>
      {/*create paper*/}
      <ConfirmationModal
        title="Do you want to complete this paper?"
        show={showPopUp2}
        onHide={hideHandler}
        yesHandler={yesHandler}
        confirmTxt="Yes"
      />
      <SuccessModal
        show={showPopUp3}
        onHide={hideHandler1}
        title="Created Paper Successfully!"
        btnTxt="Ok"
      />
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <h4>Paper Matrix</h4>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/createPaper">Create Paper</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Pending</Breadcrumb.Item>
            <Breadcrumb.Item active>Paper Matrix</Breadcrumb.Item>
            <Breadcrumb.Item active>Questions</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className={classes["pm-info-btn"]}>
          <a
            href={`/createPaper/printView?uid=${faculty_id}&sid=${sub_id}&pid=${paper_id}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginRight: '8px' }}
          >
            <SecBTN className="sec-btn1">Print</SecBTN>
          </a>
          <SecBTN className="sec-btn" onClick={paperDetailHandler}>
            Paper Details
          </SecBTN>
          <SecBTN className="sec-btn" onClick={viewSyllabusHandler}>
            View Syllabus
          </SecBTN>
        </div>
      </div>
      {!loading && (
        <Graybg>
          <h6 className="text-center mb-3 mt-2">
            <b>Paper Code : </b>
            {paper_id}
          </h6>
          {quesData.map((data, index, allData) => {
            const paraCondition =
              data.type_id == 5
                ? quesData.indexOf(data) !== quesData.length - 1
                  ? index % 2 !== 0 &&
                    data.paragraph_id === allData[index + 1]?.paragraph_id
                    ? false
                    : true
                  : data.paragraph_id === allData[index - 1]?.paragraph_id
                    ? false
                    : true
                : data.type_id == (9 || 10)
                  ? quesData.indexOf(data) !== quesData.length - 1
                    ? index % 2 !== 0 &&
                      data.paragraph_id === allData[index + 1]?.paragraph_id
                      ? false
                      : true
                    : data.paragraph_id === allData[index - 1].paragraph_id
                      ? false
                      : true
                  : false;
            return (
              <Questions
                key={index}
                data={{ ...data, faculty_id: faculty_id }}
                isBoth={isBoth}
                paraIndexCondition={paraCondition}
                replaceQuestionForNext={(datas) => {
                  replaceQuestionForNext(datas, index)
                }}
                requestRandomPaperApi={() => getRandomPaperData()}
                nextMatrixId={paraCondition ? allData[index + 1]?.matrix_id ?? 0 : 0}
              />
            );
          })}
          {/* quesData.indexOf(data) !== quesData.length - 1 */}
          <div className="d-flex justify-content-center align-items-center gap-3 mt-4 mb-2">
            <div
              className="d-flex align-items-center px-3 py-2 rounded"
              style={{
                backgroundColor: "#fff3cd",
                border: "1px solid #ffc107",
                fontWeight: 600,
              }}
            >
              <div className="final-submit-checkbox">
                <Form.Check
                  type="checkbox"
                  id="final-submit-paper"
                  label="Final Submit Paper"
                  checked={isFinalPaper}
                  onChange={(e) => setIsFinalPaper(e.target.checked)}
                />
              </div>
            </div>

            <SecBTN className="sec-btn1" onClick={finishHandler}>
              Finish Paper
            </SecBTN>
          </div>
        </Graybg>
      )}
    </div>
  );
};

export default MatrixQuestions;
